/** Condition kind in the scenarion for payment tasks */
export enum PaymentScenarionConditionKindEnum {
  /** Direction */
  DIRECTION = 'DIRECTION',
  /** Unit */
  UNIT = 'UNIT',
  /** Filial */
  FILIAL = 'FILIAL',
  /** Company */
  COMPANY = 'COMPANY',
  /** Amount value */
  AMOUNT = 'AMOUNT',
  /** Deal */
  DEAL = 'DEAL',
  /** Cost center */
  COST_CENTER = 'COST_CENTER',
  /** Exceeding plan */
  EXCEEDING_PLAN = 'EXCEEDING_PLAN',
  /** Budget is exhausted */
  BUDGET_EXHAUSTED = 'BUDGET_EXHAUSTED',
}
